import { Component, Input } from '@angular/core';
import { AiResponseAction } from '../../types/ai-response.action.type';

@Component({
  selector: 'app-ai-chat-message-action',
  templateUrl: './ai-chat-message-action.component.html',
  styleUrls: ['./ai-chat-message-action.component.css']
})
export class AiChatMessageActionComponent {

  @Input() readonly action: AiResponseAction;

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/ai-chat-message/ai-chat-message-action/ai-chat-message-action.component.ts